<template>
  <v-main>
    <div class="header">
      <MainMenu v-if="displayMenu" />
    </div>
    <Header />
    <Notice />
    <Footer v-if="displayMenu" />
  </v-main>
</template>

<script>
import Footer from "@/components/common/Footer.vue";
import Header from "@/components/LegalNotice/Header.vue";
import Notice from "@/components/LegalNotice/Notice.vue";
import MainMenu from "@/components/common/MainMenu";

export default {
  name: "LegalNotice",
  components: {
    MainMenu,
    Notice,
    Header,
    Footer,
  },
  data() {
    return {
      displayMenu: false,
    };
  },
  mounted() {
    const currentUser = localStorage.getItem("currentUser");
    this.displayMenu = currentUser === null;
  },
};
</script>

<style scoped></style>
